var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3292 0C13.9428 0 14.4403 0.497461 14.4403 1.11111H16.6625C17.8898 1.11111 18.8847 2.10603 18.8847 3.33333V5.55556C18.8847 6.1692 18.3872 6.66667 17.7736 6.66667H17.618L16.8008 17.9256C16.723 19.0929 15.7534 20 14.5835 20H5.40816C4.23824 20 3.26868 19.0929 3.19086 17.9256L2.37249 6.66667H2.21804C1.60439 6.66667 1.10693 6.1692 1.10693 5.55556V3.33333C1.10693 2.10603 2.10186 1.11111 3.32916 1.11111H5.55138C5.55138 0.497461 6.04884 0 6.66249 0H13.3292ZM15.3983 6.66667H4.59335L5.40816 17.7778H14.5835L15.3983 6.66667ZM16.6625 3.33333H3.32916V4.44444H16.6625V3.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f453a3a045cf9d7b43ddfc9053555654.svg";
export { ForwardRef as ReactComponent };